export const isFiltersModal = modalType => modalType === 'filter';
export const isColumnsModal = modalType => modalType === 'column';
